import React, { useState } from 'react';
import { Form } from 'reactstrap';
import { Box, Modal, Typography, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Select from '@material-ui/core/Select';
import { styled, makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddBoxIcon from '@material-ui/icons/AddBox';
import moment from "moment";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 600,
  width: 800,
  // bgcolor: 'background.paper',
  bgcolor: '#ffab91',
  border: '1px solid #59b9ea',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea',
  },
  '& .MuiInputBase-input': {
    // WebkitTextFillColor: 'green',
    // color: 'red',
  },
});

const CssTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    // color: 'green',
  },
  '& .MuiInputBase-input': {
    // WebkitTextFillColor: 'green',
    // WebkitTextFillColor: 'red',
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1)
    }
  },
  textarea: {
    resize: "both"
  }
}));

function MaterialInputListDelete(props) {

  const [materialJajeId] = useState(props.materialInputListDeleteValue.Id) // id
  const [materialGongJang, setMaterialGongJang] = useState(props.materialInputListDeleteValue.ms_공장구분) // 공장선택
  const [materialIpchul, setMaterialIpchul] = useState(props.materialInputListDeleteValue.ms_입고출고구분) // 입출구분
  const [materialUpche] = useState(props.materialInputListDeleteValue.ms_업체명) // 자재업체
  const [materialCodeNo] = useState(props.materialInputListDeleteValue.ms_업체코드) //자재업체코드
  const [materialSubul] = useState(props.materialInputListDeleteValue.ms_자재수불) //자재수불
  const [materialGamokCode] = useState(props.materialInputListDeleteValue.ms_계정과목코드) //계정과목코드
  const [materialGamok] = useState(props.materialInputListDeleteValue.ms_계정과목내용) //계정과목
  const [materialJajeCode] = useState(props.materialInputListDeleteValue.ms_자재코드) //자재코드
  const [materialJajeItem] = useState(props.materialInputListDeleteValue.ms_자재품번) //자재품번
  const [materialJajeStandader] = useState(props.materialInputListDeleteValue.ms_자재규격) //자재규격[품명]
  const [materialJichulBulru, setMaterialJichulBulru] = useState(props.materialInputListDeleteValue.ms_자재지출분류); //업체자재지출분류
  const [materialJajeDanwiQuantity, setMaterialJajeDanwiQuantity] = useState(props.materialInputListDeleteValue.ms_단위량) //자재단위량
  const [materialJajeDanwi, setMaterialJajeDanwi] = useState(props.materialInputListDeleteValue.ms_단위) //자재단위
  const [materialJajeDanga, setMaterialJajeDanga] = useState(props.materialInputListDeleteValue.ms_자재단가) //자재단가
  const [materialJajeIpgoQuantity, setMaterialJajeIpgoQuantity] = useState(props.materialInputListDeleteValue.ms_수량) //자재입고수량
  const [materialJajeIpgoGumackQuantity, setMaterialJajeIpgoGumackQuantity] = useState(props.materialInputListDeleteValue.ms_금액) //자재입고금액
  const [materialJajeGubun, setMaterialJajeGubun] = useState(props.materialInputListDeleteValue.ms_자재구분) //자재구분
  const [materialJajeIpChulDate, setMaterialJajeIpChulDate] = useState(props.materialInputListDeleteValue.ms_입출일자) //입출일자
  const [materialJajeDateTime, setMaterialJajeDateTime] = useState(props.materialInputListDeleteValue.ms_결재지급월) //대금지급월
  const [materialJajeIpgoGigubGumack, setMaterialJajeIpgoGigubGumack] = useState(props.materialInputListDeleteValue.ms_결재지급금액) //결재금액
  const [materialJajeJigubDateTime, setMaterialJajeJigubDateTime] = useState(props.materialInputListDeleteValue.ms_결재지급일자) //결재지급일자
  const [materialGelje, setMaterialGelje] = useState(props.materialInputListDeleteValue.ms_결재유무) //결재유무
  const [materialJajeDescription, setMaterialJajeDescription] = useState(props.materialInputListDeleteValue.ms_자재설명) //기타기록사항

  const [materialPassword, setMaterialPassword] = useState('') //삭제조건비밀번호

  const classes = useStyles();

  //공장
  let materialGongjangHandle = (e) => {
    e.preventDefault();
    setMaterialGongJang(e.target.value);
  };
  //입고출고구분
  let materialIpchulHandle = (e) => {
    e.preventDefault();
    setMaterialIpchul(e.target.value);
  };
  //자재단위량
  let materialJajeDanwiQuantityHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanwiQuantity(e.target.value);
  };
  //자재단위
  let materialJajeDanwiHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanwi(e.target.value);
  };
  //자재단가
  let materialJajeDangaHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanga(e.target.value);
    setMaterialJajeIpgoGumackQuantity(Number(e.target.value) * Number(materialJajeIpgoQuantity))
  };
  //자재입고량
  let materialJajeIpgoQuantityHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoQuantity(e.target.value);
    setMaterialJajeIpgoGumackQuantity(Number(materialJajeDanga) * Number(e.target.value))
  };

  //자재구분
  let materialJajeGubunHandle = (e) => {
    e.preventDefault();
    setMaterialJajeGubun(e.target.value);
  };

   //자재입출일자
   let materialJajeIpchulDateHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpChulDate(e.target.value);
  };

  //자재지급월
  let materialJajeDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDateTime(e.target.value);
  };
  //결재금액
  let materialJajeIpgoGigubGumackHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoGigubGumack(e.target.value);
  };

  //결재유무
  let materialGeljeHandleHandle = (e) => {
    e.preventDefault();
    setMaterialGelje(e.target.value);
  };

  //결재지급일자
  let materialJajeJigubDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeJigubDateTime(e.target.value);
  };

  //기타기록사항
  let materialJajeDescriptionHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDescription(e.target.value);
  };

  //개행처리
  const materialJajeDescriptionKeyDownHandle = (e) => {
    if (e.key === 'Enter') {
      setMaterialJajeDescription(e.target.value + "\n");  //개행처리됨.
    }
  };

  //password
  let materialPasswordHandle = (e) => {
    e.preventDefault();
    setMaterialPassword(e.target.value);
  };

  //폼전송 엔트키 전송방지
  const checkKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    formData.append('Id', materialJajeId)

    if (materialPassword === 'dumbness') {  //우리나라대한민국
      props.setMaterialInputListDeleteModal(false);
      props.setMaterialInputListPasswordTrue(true)  //삭제실행 true 이면
    }
    else {
      alert("삭제조건이 맞지 안습니다. 다시입력하세요")
    }
  }

  return (
    <div>
      <Modal open={props.materialInputListDeleteModal}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: 'D2Coding',
                fontSize: '24px',
                color: 'green',
              }}
            >
              구매자재[입출]삭제
            </Typography>
          </div>

          <Form onSubmit={handleSubmit} onKeyDown={checkKeyDown}>
            <div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 200, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialUpche === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체상호"
                  name="materialUpche"
                  size="small"
                  value={materialUpche === '' ? '' : materialUpche}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialCodeNo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="업체코드"
                  name="materialCodeNo"
                  size="small"
                  value={materialCodeNo === '' ? '' : materialCodeNo}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialSubul === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재수불"
                  name="materialSubul"
                  size="small"
                  value={materialSubul === '' ? '' : materialSubul}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 120, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialGamokCode === '' ? { shrink: false } : { shrink: true }
                  }
                  label="계정과목코드"
                  name="materialGamoKCode"
                  size="small"
                  value={materialGamokCode === '' ? '' : materialGamokCode}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialGamok === '' ? { shrink: false } : { shrink: true }
                  }
                  label="과목"
                  name="materialGamok"
                  size="small"
                  value={materialGamok === '' ? '' : materialGamok}
                />
              </div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  // onChange={materialJajeCodeNoHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeCode === '' ? { shrink: false } : { shrink: true }
                  }
                  id=""
                  label="자재코드"
                  name="materialJajeCodeNo"
                  size="small"
                  value={materialJajeCode ? materialJajeCode : ''}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeItem === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재품번"
                  name="materialJajeItem"
                  size="small"
                  value={materialJajeItem ? materialJajeItem : ''}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 250, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeStandader === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재규격[품명]"
                  name="materialJajeStandader"
                  size="small"
                  value={materialJajeStandader ? materialJajeStandader : ''}
                />
                <TextField
                  disabled
                  // required //필수등록
                  style={{ width: 140, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJichulBulru === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재지출분류"
                  name="materialJichulBulru"
                  size="small"
                  value={materialJichulBulru ? materialJichulBulru : ''}
                />
              </div>
              <hr />
              <div>
                <FormControl
                  disabled
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 150, float: 'center', marginTop: '0px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>공장</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialGongJang ? materialGongJang : ''}
                    onChange={materialGongjangHandle}
                    label="공장"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                    <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                  </CssSelect>
                </FormControl>
                <FormControl
                  disabled
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '0px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>입출</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialIpchul ? materialIpchul : ''}
                    onChange={materialIpchulHandle}
                    label="입출"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'입고'}>입고</MenuItem>
                    <MenuItem value={'출고'}>출고</MenuItem>
                  </CssSelect>
                </FormControl>
              </div>
              <div>
                <CssTextField
                  disabled
                  required //필수등록
                  style={{ width: 150, float: 'center', marginRight: '2px', marginTop: '1px', textAlign: 'right' }}
                  variant="outlined"
                  onChange={materialJajeDanwiQuantityHandle}
                  InputLabelProps={
                    materialJajeDanwiQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="단위량[단위별]"
                  name="materialJajeDanwiQuantity"
                  size="small"
                  value={materialJajeDanwiQuantity ? materialJajeDanwiQuantity : ''}
                />
                <FormControl
                  disabled
                  required
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '1px', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel>단위</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJajeDanwi ? materialJajeDanwi : ''}
                    onChange={materialJajeDanwiHandle}
                    label="단위"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'원'}>원</MenuItem>
                    <MenuItem value={'g'}>g</MenuItem>
                    <MenuItem value={'Kg'}>Kg</MenuItem>
                    <MenuItem value={'Ea'}>Ea[개]</MenuItem>
                    <MenuItem value={'Box'}>Box</MenuItem>
                    <MenuItem value={'Can'}>Can</MenuItem>
                    <MenuItem value={'㎖'}>㎖</MenuItem>
                    <MenuItem value={'ℓ'}>ℓ</MenuItem>
                    <MenuItem value={'갤런(gal)'}>갤런(gal)</MenuItem>
                    <MenuItem value={'말'}>말</MenuItem>
                    <MenuItem value={'포'}>포</MenuItem>
                    <MenuItem value={'드럼'}>드럼</MenuItem>
                    <MenuItem value={'mm'}>mm</MenuItem>
                    <MenuItem value={'Cm'}>Cm</MenuItem>
                    <MenuItem value={'m'}>m</MenuItem>
                    <MenuItem value={'P/L'}>P/L[파렛트]</MenuItem>
                    <MenuItem value={'월'}>월</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  disabled
                  required //필수등록
                  onChange={materialJajeDangaHandle}
                  style={{ width: 100, float: 'center', marginTop: '1px', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeDanga === '' ? { shrink: false } : { shrink: true }
                  }
                  label="단가"
                  name="materialJajeDanga"
                  size="small"
                  value={materialJajeDanga ? materialJajeDanga : ''}
                />
              </div>
              <div>
                <CssTextField
                  disabled
                  required //필수등록
                  onChange={materialJajeIpgoQuantityHandle}
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="입고량"
                  name="materialJajeDanga"
                  size="small"
                  value={materialJajeIpgoQuantity ? materialJajeIpgoQuantity : ''}
                />
                <CssTextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="금액"
                  name="materialJajeIpgoGumackQuantity"
                  size="small"
                  value={materialJajeIpgoGumackQuantity ? materialJajeIpgoGumackQuantity : ''}
                />
              </div>
              <div>
                <FormControl
                  disabled
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel>자재구분</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJajeGubun ? materialJajeGubun : ''}
                    onChange={materialJajeGubunHandle}
                    label="자재구분"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'피착'}>피착</MenuItem>
                    <MenuItem value={'피막'}>피막</MenuItem>
                    <MenuItem value={'착색'}>착색</MenuItem>
                    <MenuItem value={'접착'}>접착</MenuItem>
                    <MenuItem value={'에칭'}>에칭</MenuItem>
                    <MenuItem value={'공통'}>공통</MenuItem>
                    <MenuItem value={'기타'}>기타</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  disabled
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="자재입출일자"
                  type="date"
                  //type="datetime-local"
                  format="yyyy-MM-dd"
                  value={moment(materialJajeIpChulDate).format('YYYY-MM-DD')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeIpchulDateHandle}
                />
              </div>
              <div>
                <CssTextField
                  disabled
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="지불월"
                  // type="month"
                  type="month"
                  format="yyyy-MM"
                  // value={moment().format('yyyy-MM')}
                  value={moment(materialJajeDateTime).format('YYYY-MM')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeDateTimeHandle}
                />
                <IconButton
                  onClick={() => { setMaterialJajeDateTime(moment().format('yyyy-MM')) }}
                  style={{ padding: '8px 0px 0px 0px' }} >
                  <AddBoxIcon style={{ fontSize: 40, margin: 0, color: 'green' }} />
                </IconButton>
                <CssTextField
                  disabled
                  // required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="결재금액"
                  name="materialJajeIpgoGigubGumack"
                  size="small"
                  value={materialJajeIpgoGigubGumack ? materialJajeIpgoGigubGumack : ''}
                  onChange={materialJajeIpgoGigubGumackHandle}
                />
                <FormControl
                  disabled
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '10px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>결재</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialGelje ? materialGelje : ''}
                    onChange={materialGeljeHandleHandle}
                    label="결재"
                  >
                    {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                    <MenuItem value={'미결'}>미결</MenuItem>
                    <MenuItem value={'즉시'}>즉시</MenuItem>
                    <MenuItem value={'결재'}>결재</MenuItem>
                    <MenuItem value={'보류'}>보류</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  disabled
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="결재지급일자"
                  type="datetime-local"
                  format="yyyy-MM-dd HH:mm"
                  // value={moment().format('yyyy-MM')}
                  value={moment(materialJajeJigubDateTime).format('YYYY-MM-DD HH:mm')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeJigubDateTimeHandle}
                />
              </div>
              <div>
                <CssTextField
                  disabled
                  style={{ width: 300, marginTop: '10px' }}
                  label="Discription[기타기록]"
                  placeholder="기타 기록하기"
                  multiline
                  variant="outlined"
                  value={materialJajeDescription}
                  inputProps={{ className: classes.textarea }}
                  onChange={materialJajeDescriptionHandle}
                  onKeyDown={materialJajeDescriptionKeyDownHandle}
                />
              </div>
              <div>
                <TextField
                  required
                  error
                  onChange={materialPasswordHandle}
                  style={{ width: 300, marginTop: '10px', float: 'center', marginRight: '2px', font: '20px' }}
                  // variant="filled"
                  InputLabelProps={
                    materialPassword === '' ? { shrink: false } : { shrink: true }
                  }
                  type='password'
                  label="삭제조건입력"
                  name="materialPassword"
                  size="small"
                  value={materialPassword ? materialPassword : ''}
                />
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                type="submit"
                startIcon={<DeleteForeverIcon />}
                variant="contained"
                style={{
                  height: '37px',
                  background: '#388e3c',
                  color: 'white',
                  width: 100,
                  marginRight: '2px',
                  float: 'center',
                }}
              >
                삭제
              </Button>
              <Button
                onClick={() => {
                  props.setMaterialInputListDeleteModal(false);
                }}
                variant="contained"
                startIcon={<CloseIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                나가기
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
    </div>
  );
}

export default MaterialInputListDelete;
